export class CreateProductionRunDelivery {

    /** What the run is made from; the same address creates a run from pickups, so the body says which */
    public readonly source: string = 'shipments';

    public shipmentId : number|undefined;

}
